import React from 'react';
import type { BombiixIconProps } from './types';

/**
 * Bombiix Sort Ascending icon — upward arrow.
 * Exported 1:1 from Figma (node 5124:195038 — Bombiix 2026). Uses
 * `stroke=currentColor` so the parent drives the tint. Flip vertically
 * (`transform: scaleY(-1)`) to render the Sort Descending variant.
 */
const SortAscendingIcon: React.FC<BombiixIconProps> = ({ size = 20, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...rest}>
    <g transform="translate(2 2)">
      <path
        d="M8 12.6666L8 3.9999M4 7.33323L7.5286 3.80464C7.78894 3.54429 8.21106 3.54429 8.4714 3.80464L12 7.33323"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
      />
    </g>
  </svg>
);

export default SortAscendingIcon;
